import React from 'react';
import './Problem.css';

const problemPoints = [
  { title: 'Scattered Client Data', content: 'Client details live in spreadsheets and emails, making it hard to link invoices, income, expenses, and communication.' }, // [attached_file:file:37]
  { title: 'No Project Structure', content: 'Projects lack phase-wise planning, task allocation, and milestone billing—deadlines slip and cash flow stalls.' }, // [attached_file:file:37]
  { title: 'Manual Quotes & Invoices', content: 'Creating GST-compliant quotes/invoices takes time; taxes, discounts, and totals-in-words are error-prone.' }, // [attached_file:file:37]
  { title: 'Poor Quote→Cash Handoffs', content: 'Quotes aren’t tracked through acceptance to invoicing; reminders and status updates fall through the cracks.' }, // [attached_file:file:37]
  { title: 'Subscription Billing Chaos', content: 'Repeat billing relies on calendars and memory; no automated cycles, no parent–child view, and late reminders.' }, // [attached_file:file:37]
  { title: 'Untracked Income & Spend', content: 'Financial entries are scattered; no bulk uploads, validation, or unified dashboard to see cash flow clearly.' }, // [attached_file:file:37]
  // { title: 'Inventory Blind Spots', content: 'No real-time stock visibility, reorder thresholds, or costing methods, leading to stockouts and margin misses.' }, // [attached_file:file:37]
];

function Problem() {
  return (
    <section id="problem" className="problem-section container full-screen">
      <h2 className="problem-title fade-up">Stop the Chaos. Start Growing.</h2>
      <p className="problem-statement fade-up">
        Your core operations are split across tools and files. Clients, projects, invoices, and money flows never line up when you need them. That means late billing, missed follow-ups, and decisions made without the full picture. BOSS fixes the root problems with connected modules built for service businesses. {/* [attached_file:file:37] */}
      </p>

      <h3 className="section-subtitle fade-up">What’s Blocking Your Growth:</h3>
      <div className="points-grid fade-up">
        {problemPoints.map(({ title, content }, i) => (
          <div key={i} className="point-card fade-up">
            <h4 className="point-title">{title}</h4>
            <p>{content}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Problem;
